import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Selector } from '@utils/constants';
import { useSearchParams } from 'react-router';
import ActivitiesGrid from '@components/activity/ActivitiesGrid';
import styles from './styles.module.scss';
import { SelectorParser } from '@utils/constants';

const CityOptions = [
    { name: '悉尼', value: Selector.Sydney },
    { name: '墨尔本', value: Selector.Melbourne },
    { name: '布里斯班', value: Selector.Brisbane },
    { name: '黄金海岸', value: Selector.GoldCoast },
    { name: '凯恩斯', value: Selector.Cairns },
    { name: '阿德莱德', value: Selector.Adelaide },
    { name: '佩斯', value: Selector.Perth },
    { name: '堪培拉', value: Selector.Canberra },
    { name: '塔斯马尼亚', value: Selector.Tasmania },
    { name: '汉密尔顿岛', value: Selector.HamiltonIsland },
    { name: '乌鲁鲁', value: Selector.Uluru },
    { name: '达尔文', value: Selector.Darwin },
    { name: '新西兰', value: Selector.NewZealand },
    { name: '悉尼周边', value: Selector.NSW },
    { name: '墨尔本周边', value: Selector.VIC },
    { name: '布里斯班周边', value: Selector.QLD },
    { name: '阿德莱德周边', value: Selector.SA },
    { name: '佩斯周边', value: Selector.WA },
];

function DomesticPage() {
    const activities = useSelector((state) => state.activities.data);
    const fetching = useSelector((state) => state.activities.fetching);
    const [searchParams, setSearchParams] = useSearchParams();
    const [citySelector, setCitySelector] = useState();

    const [data, setData] = useState([]);

    useEffect(() => {
        filterActivities();
        const params = new URLSearchParams(searchParams);
        const citySelector = params.get('city');
        setCitySelector(citySelector);
    }, [fetching, searchParams]);

    const filterActivities = () => {
        // Accept an array of selectors instead of a single fixed one
        let selectedSelectors = [Selector.Package, Selector.Team]; // match any of these selectors
        const params = new URLSearchParams(searchParams);
        const sort = params.get('sort');
        const citySelector = params.get('city');

        let newData = [...activities];

        // Filter for multiple selectors
        newData = activities.filter((item) => {
            // Check if activity matches ANY of the selected selectors
            return selectedSelectors.some((selector) => item.selectors?.includes(selector));
        });

        // Filter by city
        if (citySelector) {
            newData = newData.filter((item) => item.selectors?.includes(citySelector));
        }

        // Modified selector sorting to handle multiple selectors
        newData?.sort((a, b) => {
            // Get the lowest sort value among all matching selectors for each item
            const getMinSortValue = (activity) => {
                const matchingItems = activity.selectorItems
                    .filter((item) => selectedSelectors.includes(item.name))
                    .map((item) => item.sort);
                return Math.min(...matchingItems);
            };

            const sortA = getMinSortValue(a);
            const sortB = getMinSortValue(b);
            return sortA - sortB;
        });

        // Price sorting remains the same
        if (sort) {
            const calculatePrice = (pricing) => {
                if (pricing.bundlePriced) {
                    return pricing.bundlePrice;
                }
                return pricing.adultPrice;
            };

            switch (sort) {
                case 'price-asc':
                    newData?.sort((a, b) => {
                        return calculatePrice(a.pricing) - calculatePrice(b.pricing);
                    });
                    break;
                case 'price-desc':
                    newData?.sort((a, b) => {
                        return calculatePrice(b.pricing) - calculatePrice(a.pricing);
                    });
                    break;
                default:
                    break;
            }
        }
        setData(newData);
    };

    const handleOnChangeFilter = (e, value) => {
        const params = new URLSearchParams(searchParams);
        const citySelector = params.get('city');
        if (citySelector == value) {
            params.delete('city');
        } else {
            params.set('city', value);
        }
        setSearchParams(params);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                一日游 / 当地参团 / 当地包团 {citySelector && `(${SelectorParser(citySelector)} ${data.length}个)`}{' '}
            </div>
            {fetching && <div>加载中...</div>}

            <div className={styles.content_container}>
                <div className={styles.filter_container}>
                    <div className={styles.filter}>
                        <div className={styles.city_container}>
                            <div className={styles.title}>城市</div>
                            {CityOptions.map((item, index) => {
                                return (
                                    <div key={index} className={styles.item_container}>
                                        <div className={styles.checkbox_container}>
                                            <input
                                                name={item.value}
                                                type="checkbox"
                                                id={item.value}
                                                value={item.value}
                                                onChange={(e) => handleOnChangeFilter(e, item.value)}
                                                checked={citySelector == item.value}
                                            />
                                            <label htmlFor={item.value}>{item.name}</label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className={styles.grid_container}>
                    <ActivitiesGrid activities={data} isFromPrice={true} />
                </div>
            </div>
        </div>
    );
}

export default DomesticPage;
